import { Availability } from "../../types/availability";
import { APIResponseType } from "../../types/generics/APIResponse.type";
import {
  createDeleteApiHook,
  createGetApiHook,
  createPostApiHook,
} from "./apiHooks";

const getTalentAvailability = ({ id }: { id: string | undefined }) =>
  `/talents/availability/${id}`;

const setUserAvailabilityEndpoint = ({ id }: { id: string }) =>
  `/users/talents/availability/${id}`;
const deleteAvailabilityEndpoint = ({
  id,
  talent_id,
}: {
  id: string;
  talent_id: string;
}) => `/users/talents/availability/${talent_id}/${id}`;

export const useGetTalentAvailability = createGetApiHook<
  APIResponseType<Availability[]>,
  { id: string | undefined }
>(getTalentAvailability);

export const useCreateTalentAvailability = createPostApiHook<
  {},
  { id: string },
  APIResponseType<Availability>
>(setUserAvailabilityEndpoint, {
  isFormDataMethod: false,
});

export const useDeleteTalentSlot = createDeleteApiHook<
  {},
  { id: string; talent_id: string },
  APIResponseType<Availability>
>(deleteAvailabilityEndpoint, {
  isFormDataMethod: false,
});
